import React from "react";
import BankAccountVendorCustomerGenericSkeleton from "./BankAccountVendorCustomerGenericSkeleton";

function BankAccountVendorCustomerDetailSkeleton() {
  return (
    <>
      <BankAccountVendorCustomerGenericSkeleton />
    </>
  );
}

export default BankAccountVendorCustomerDetailSkeleton;
